import { Tag } from 'antd';
import type { CatalogoRef } from '@aid/shared';

interface TipoClienteTagProps {
  tipo: CatalogoRef | null;
}

export function TipoClienteTag({ tipo }: TipoClienteTagProps) {
  if (!tipo) return <Tag>N/A</Tag>;
  return <Tag>{tipo.value ?? tipo.key ?? 'N/A'}</Tag>;
}
